<div class="CommonDropdown" [class.compact]="compact">
  <label>{{ resolvedConfig.label | t:resolvedConfig.label }}</label>

  <div class="select-wrap" *ngIf="!resolvedConfig.isSearchable">
    <select
      [ngModel]="resolvedValue()"
      (ngModelChange)="onSelectionChange($event)"
      [disabled]="isLoading || !!error"
    >
      <option [ngValue]="null" disabled>{{ resolvedConfig.placeholder | t:resolvedConfig.placeholder }}</option>
      <option *ngFor="let item of filteredOptions" [ngValue]="item.value">
        {{ item.display }}
      </option>
    </select>
    <button
      *ngIf="value !== null && value !== undefined && value !== ''"
      class="clear-btn"
      type="button"
      [attr.aria-label]="'common.clearSelection' | t:'Clear selection'"
      (click)="clearSelection($event)"
    >
      &times;
    </button>
  </div>

  <div class="select-wrap searchable" *ngIf="resolvedConfig.isSearchable">
    <input
      type="text"
      [ngModel]="searchText"
      (ngModelChange)="onSearchableInput($event)"
      (focus)="openSearchMenu()"
      (blur)="closeSearchMenu()"
      [placeholder]="resolvedConfig.placeholder | t:resolvedConfig.placeholder"
      [readonly]="searchReadonly"
      [disabled]="isLoading || !!error"
      [class.highlighted-selection]="isHighlightedOption(selectedOption())"
      autocomplete="off"
    />
    <button
      *ngIf="value !== null && value !== undefined && value !== ''"
      class="clear-btn"
      type="button"
      [attr.aria-label]="'common.clearSelection' | t:'Clear selection'"
      (click)="clearSelection($event)"
    >
      &times;
    </button>

    <div class="search-menu" *ngIf="isSearchMenuOpen">
      <button
        class="search-option"
        [class.highlighted-option]="isHighlightedOption(item)"
        type="button"
        *ngFor="let item of filteredOptions"
        (mousedown)="selectOption(item)"
      >
        {{ item.display }}
      </button>
      <div class="search-empty" *ngIf="filteredOptions.length === 0">{{ 'common.noOptionFound' | t:'No option found' }}</div>
    </div>
  </div>

  <div class="msg error" *ngIf="error">{{ error | t:error }}</div>
  <div class="msg info" *ngIf="isLoading && !resolvedConfig.hideLoadingMessage">{{ 'common.loading' | t:'Loading...' }}</div>
</div>
